"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* global __DEV__ */
var _require = require('ramda'),
    add = _require.add,
    concat = _require.concat,
    curry = _require.curry,
    identity = _require.identity,
    map = _require.map,
    memoizeWith = _require.memoizeWith,
    slice = _require.slice,
    split = _require.split,
    pipe = _require.pipe,
    drop = _require.drop,
    take = _require.take,
    trim = _require.trim;

var E_TOKEN_LENGTH = new SyntaxError('Left and right tokens must have equal width');
var LEFT_TOKEN = '{{';
var RIGHT_TOKEN = '}}';
var PIPE_TOKEN = '|';
var PARAMETERS_LEFT_TOKEN = '(';
var PARAMETERS_RIGHT_TOKEN = ')';
var E_TOKEN_MISSING = new SyntaxError("One of closing tokens '".concat(RIGHT_TOKEN, "' not found"));
var TOKEN_LENGTH = LEFT_TOKEN.length === RIGHT_TOKEN.length && LEFT_TOKEN.length;
var PARAMETERS_TOKEN_LENGTH = PARAMETERS_LEFT_TOKEN.length === PARAMETERS_RIGHT_TOKEN.length && PARAMETERS_LEFT_TOKEN.length; // sanity check

if (!TOKEN_LENGTH || !PARAMETERS_TOKEN_LENGTH) {
  throw E_TOKEN_LENGTH;
} // shortcut for token offset calculation


var offset = add(TOKEN_LENGTH);
var parametersOffset = add(PARAMETERS_TOKEN_LENGTH); // string-friendly slice with trim

var extractItem = curry(function (start, end, input) {
  return pipe( // get desired part
  slice(start, end), // trim unneeded space
  trim)(input);
}); // raw parameters extraction helper

var extractParameters = curry(function (start, end, input) {
  return pipe( // get desired part
  extractItem(start, end), // split by commas
  split(','), // trim unneded space for every item
  map(trim))(input);
}); // --

function parseProcessor(input) {
  var leftStart = input.indexOf(PARAMETERS_LEFT_TOKEN);
  var rightStart = input.indexOf(PARAMETERS_RIGHT_TOKEN);

  if (leftStart === -1 || rightStart === -1) {
    // if one of tokens is present
    if (leftStart !== rightStart) {
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.warn("Brackets mismatch in processor declaration: ".concat(input));
      }

      return null;
    }

    return {
      name: input,
      type: 'processor',
      parameters: []
    };
  }

  var leftEnd = parametersOffset(leftStart);
  var name = take(leftStart, input);
  var parameters = extractParameters(leftEnd, rightStart, input);
  return {
    name: name,
    type: 'processor',
    parameters: parameters
  };
}

function parseVariable(input) {
  // if PIPE_TOKEN is present
  if (input.indexOf(PIPE_TOKEN) > -1) {
    // extract variable name and processor
    var _pipe = pipe(split(PIPE_TOKEN), map(trim))(input),
        _pipe2 = _slicedToArray(_pipe, 2),
        name = _pipe2[0],
        processorString = _pipe2[1];

    var processor = parseProcessor(processorString);
    return {
      name: name,
      type: 'variable',
      processor: processor
    };
  } // else treat input as variable name


  return {
    name: trim(input),
    type: 'variable'
  };
} // --


module.exports = memoizeWith(identity, function parse(input, _result) {
  var leftStart = input.indexOf(LEFT_TOKEN);
  var rightStart = input.indexOf(RIGHT_TOKEN);
  var leftEnd = offset(leftStart);
  var rightEnd = offset(rightStart); // create shortcut function

  function appendResult(x) {
    return concat(_result || [], [x]);
  }

  if (leftStart === -1 || rightStart === -1) {
    // if one of tokens is present
    if (leftStart !== rightStart) {
      throw E_TOKEN_MISSING;
    }
  } // if LEFT_TOKEN is present, start recursion


  if (leftStart > -1) {
    // if string begins with LEFT_TOKEN
    if (leftStart === 0) {
      // extract variable
      var _item = parseVariable(extractItem(leftEnd, rightStart, input));

      return parse(drop(rightEnd, input), appendResult(_item));
    } // else extract string up to the next LEFT_TOKEN


    var item = take(leftStart, input);
    return parse(drop(leftStart, input), appendResult(item));
  } // if we have string left


  if (input.length) {
    // append it to the result
    return appendResult(input);
  } // else just return the result


  return _result;
});